document.addEventListener('DOMContentLoaded', function () {
  function initJudgeMeReadMore() {
    const reviewBodies = document.querySelectorAll('.jdgm-rev__body');

    reviewBodies.forEach((body) => {
      if (body.dataset.readmoreInit === 'true') return;

      const fullText = body.textContent.trim();
      const limit = 80;

      if (fullText.length <= limit) return;

      const fullHtml = body.innerHTML;
      const shortText = fullText.substring(0, limit) + '...';

      body.dataset.readmoreInit = 'true';
      body.dataset.fullHtml = fullHtml;
      body.dataset.shortText = shortText;
      body.dataset.expanded = 'false';

      body.innerHTML = '<p>' + shortText + '</p>';

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'jdgm-read-more-toggle';
      toggle.textContent = 'Ver más';

      toggle.addEventListener('click', function () {
        const expanded = body.dataset.expanded === 'true';

        if (expanded) {
          body.innerHTML = '<p>' + body.dataset.shortText + '</p>';
          toggle.textContent = 'Ver más';
          body.dataset.expanded = 'false';
          toggle.className = 'jdgm-read-more-toggle';
        } else {
          body.innerHTML = body.dataset.fullHtml;
          toggle.textContent = 'Ver menos';
          body.dataset.expanded = 'true';
          toggle.className = 'jdgm-read-less-toggle';
        }
      });

      body.insertAdjacentElement('afterend', toggle);
    });
  }

  initJudgeMeReadMore();

  const observer = new MutationObserver(() => {
    initJudgeMeReadMore();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});